var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-select", {
    staticClass: "managed-by-select py-0",
    attrs: {
      value: _vm.value,
      items: _vm.items,
      placeholder: _vm.$t("placeholder"),
      "hide-details": "",
      "data-testid": "managed-by-select",
    },
    on: {
      change: function (selected) {
        return _vm.$emit("input", selected)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }